<footer class="site-footer">

    <!-- Franja superior -->
    <div class="footer-top">
        <div class="container">
            <div class="row align-items-start">

                <!-- Columna 1: Logo y descripción -->
                <div class="col-12 col-md-4 footer-brand mb-4 mb-md-0">
                    <a routerLink="/ciudadano" class="footer-logo-link">
                        <img src="assets/images/logo-boca.png" height="56px" alt="Boca Digital">
                    </a>
                    <p class="footer-desc mt-3">
                        Portal ciudadano del H. Ayuntamiento de Boca del Río, Veracruz.<br>
                        Trámites y servicios en línea para los ciudadanos.
                    </p>
                </div>

                <!-- Columna 2: Navegación -->
                <div class="col-6 col-md-2 mb-4 mb-md-0">
                    <h6 class="footer-heading">Portal</h6>
                    <ul class="footer-list">
                        <li><a routerLink="/ciudadano/tramites">Trámites en línea</a></li>
                        <li><a routerLink="/reportes-atendidos">Reportes ciudadanos</a></li>
                        <li><a routerLink="/ciudadano/iniciar-sesion">Iniciar sesión</a></li>
                        <li><a routerLink="/ciudadano/crear-cuenta">Crear cuenta</a></li>
                    </ul>
                </div>

                <!-- Columna 3: Legal -->
                <div class="col-6 col-md-2 mb-4 mb-md-0">
                    <h6 class="footer-heading">Legal</h6>
                    <ul class="footer-list">
                        <li><a href="#">Aviso de privacidad</a></li>
                        <li><a href="#">Términos y condiciones</a></li>
                        <li><a href="#">Preguntas frecuentes</a></li>
                    </ul>
                </div>

                <!-- Columna 4: Contacto -->
                <div class="col-12 col-md-4 mb-4 mb-md-0">
                    <h6 class="footer-heading">Contacto</h6>
                    <ul class="footer-list footer-contact">
                        <li>
                            <i class="fa fa-map-marker mr-2"></i>
                            Av. Revolución 1000, Zona Centro, Cabecera Municipal, 94290 Boca del Río, Ver.
                        </li>
                        <li>
                            <i class="fa fa-phone mr-2"></i>
                            +52 229 202 2200
                        </li>
                        <li>
                            <i class="fa fa-envelope mr-2"></i>
                            contacto@bocadelrio.gob.mx
                        </li>
                    </ul>
                </div>

            </div>
        </div>
    </div>

    <!-- Franja inferior: copyright -->
    <div class="footer-bottom">
        <div class="container">
            <span>© {{ year }} H. Ayuntamiento de Boca del Río, Veracruz. Todos los derechos reservados.</span>
        </div>
    </div>

</footer>
